import { LogOut, Settings } from "lucide-react";

import { AppSettings } from "./AppSettings";
import { SourceSettings } from "./SourceSettings";
import { supabase } from "@/lib/supabase";
import type {
  NewsroomSettings,
  NewsSource,
  ProviderUsage,
} from "@/lib/types";

export function SettingsPage({
  ownerId,
  settings,
  sources,
  usage,
  onRefreshSettings,
  onRefreshSources,
}: {
  ownerId: string;
  settings: NewsroomSettings;
  sources: NewsSource[];
  usage: ProviderUsage[];
  onRefreshSettings: () => Promise<void>;
  onRefreshSources: () => Promise<void>;
}) {
  return (
    <section className="settings-page">
      <header className="settings-header">
        <div>
          <p className="eyebrow">SETTINGS</p>
          <h1>Newsroom controls</h1>
          <p>
            Manage discovery sources, drafting preferences, verification, and
            notifications in one place.
          </p>
        </div>
        <Settings aria-hidden="true" className="header-icon" />
      </header>

      <div className="settings-stack">
        <AppSettings
          settings={settings}
          usage={usage}
          onSaved={onRefreshSettings}
        />
        <SourceSettings
          ownerId={ownerId}
          sources={sources}
          onRefresh={onRefreshSources}
        />
        <section className="settings-section account-section">
          <div>
            <p className="eyebrow">ACCOUNT</p>
            <h2>Session</h2>
            <p>Sign out of this private newsroom on the current device.</p>
          </div>
          <button
            type="button"
            className="button-secondary"
            onClick={() => void supabase.auth.signOut()}
          >
            <LogOut aria-hidden="true" />
            Sign out
          </button>
        </section>
      </div>
    </section>
  );
}
